module.exports = __webpack_public_path__ + "static/experience_excellence-4a507d234c770ab9c2076664829fcb14.mp4";